import { Model } from '@vuex-orm/core';
import STORE from '@/store/STORE';

const { name } = STORE.modules.mixinComponents;

export default class MixinComponents extends Model {
  static entity = `${ name }`;

  static primaryKey = 'trial_id';

  static fields() {
    return {
      trial_id: this.attr(null),
      recipes: this.attr([]),
      premixes: this.attr([]),
    };
  }

  static methodConf = {
    http: {
      url: '/modules/mixing',
    },
    methods: {
      $get: {
        name: 'get',
        http: {
          url: '/:id/components',
          method: 'get',
        },
      },
    },
  };
}
